/**
 * TopicCardState — the currently-displayed topic card data, or null
 * if no topic is active. Updated when Guide returns a topic in an
 * IACP response (optionally after Wikipedia enrichment).
 *
 * Emits `topic:changed` on mutation.
 */
export class TopicCardState {
    constructor(_bus) {
        this._bus = _bus;
        this._topic = null;
        this._isEnriching = false;
        /**
         * Monotonic identity of the CURRENT card. Every setTopic() bumps it; async
         * enrichment captures the epoch at start and merges ONLY if the card hasn't
         * changed since. Without this, a slow Wikipedia/Places lookup for topic A
         * resolved AFTER the user walked on and stamped A's image onto topic B —
         * the classic "wrong photo on the card" bug.
         */
        this._epoch = 0;
    }
    setTopic(topic, keepEnriching) {
        this._epoch++;
        this._topic = topic;
        if (!keepEnriching)
            this._isEnriching = false;
        this._bus.emit('topic:changed', { topic: this._topic, isEnriching: this._isEnriching });
    }
    setEnriching(enriching) {
        this._isEnriching = enriching;
        this._bus.emit('topic:changed', { topic: this._topic, isEnriching: enriching });
    }
    /** Epoch of the current card — capture BEFORE starting async enrichment. */
    get epoch() {
        return this._epoch;
    }
    /**
     * Apply enrichment results from WikipediaEnricher on top of the current topic.
     * `forEpoch`: pass the epoch captured when the enrichment started; if the card
     * changed in the meantime the patch is dropped (stale async result). Omitting
     * it keeps the legacy unguarded behavior for synchronous callers.
     */
    mergeEnrichment(patch, forEpoch) {
        if (!this._topic)
            return;
        if (forEpoch !== undefined && forEpoch !== this._epoch)
            return; // stale async result
        this._topic = { ...this._topic, ...patch };
        this._isEnriching = false;
        this._bus.emit('topic:changed', { topic: this._topic, isEnriching: false });
    }
    get topic() {
        return this._topic;
    }
    get isEnriching() {
        return this._isEnriching;
    }
}
//# sourceMappingURL=TopicCardState.js.map